import { DataTableActions } from "./toolbar-options/data-table-actions";
import { DataTableFilters } from "./toolbar-options/data-table-filters";
"use client";

import { Table } from "@tanstack/react-table";


import { useCallback, useRef } from "react";
import { useTaxWorkflowFilterActions } from "../../filter/hooks/actions";

import { useFilterState } from "../../filter/hooks/filterState";
import { DateRangePicker, DateRangePickerRef } from "./toolbar-options/date-range-picker";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
  refetch?: () => void;
}

export function DataTableToolbar<TData>({
  table,
  refetch,
}: DataTableToolbarProps<TData>) {
  const filterState = useFilterState();
  const { updateFilter, resetFilters } = useTaxWorkflowFilterActions();

  if (filterState.filters.meta.page === undefined) {
    console.log(table)
  }

  const handleDateRangeChange = useCallback(
    (startDate: string | undefined, endDate: string | undefined) => {
      updateFilter({ key: "from_date", value: startDate || "" });
      updateFilter({ key: "to_date", value: endDate || "" });
    },
    [updateFilter]
  );

  const dateRangePickerRef = useRef<DateRangePickerRef>(null);

  return (
    <div className="flex flex-col gap-2 w-full items-center">
      <div className="flex flex-wrap items-center justify-between w-full">
        <DataTableFilters
          filterState={filterState}
          updateFilter={updateFilter}
          resetFilters={() => {
            resetFilters();
            dateRangePickerRef.current?.clear();
          }}
          refetch={refetch}
        />
        <div className="flex flex-col">
          <label htmlFor="date_range" className="text-sm font-medium text-gray-700">
            Período
          </label>
          <DateRangePicker
            ref={dateRangePickerRef}
            onDateChange={handleDateRangeChange}
          />
        </div>
      </div>
      <DataTableActions />
    </div>
  );
}
